<h1 mat-dialog-title>{{ header }}</h1>
<div mat-dialog-content>
  <app-add-product-form
    [store]="data.store"
    (addedProduct)="submitProduct($event)"
  ></app-add-product-form>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ cancelButton }}</button>
</div>
